// Friendly names for checklist field types (values match backend forms.VALID_TYPES).
export const FIELD_TYPES = [
  { value: "checkbox", label: "Tick box" },
  { value: "short_text", label: "Text (short)" },
  { value: "long_text", label: "Text (long)" },
  { value: "dropdown", label: "Drop-down (pick one)" },
  { value: "multiple_choice", label: "Multiple choice (pick many)" },
  { value: "yes_no", label: "Yes / No" },
  { value: "pass_fail", label: "Pass / Fail" },
  { value: "number", label: "Number" },
  { value: "date", label: "Date" },
  { value: "time", label: "Time" },
  { value: "photo", label: "Photo" },
  { value: "signature", label: "Signature" },
  { value: "info", label: "Information (no answer)" },
];

export const typeLabel = (v) => FIELD_TYPES.find((f) => f.value === v)?.label || v;
export const HAS_OPTIONS = ["dropdown", "multiple_choice"];
